import { render, staticRenderFns } from "./ViewTemplatesNotification.vue?vue&type=template&id=39366bac&"
import script from "./ViewTemplatesNotification.vue?vue&type=script&lang=js&"
export * from "./ViewTemplatesNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports